import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getTaxReport } from 'services/reports/tax.service';

/**
 * Custom hook to fetch and cache the tax report.
 * @param {Object} params - Query filter parameters
 * @returns {Object} React Query hook result
 */
export default function useTaxReport(params) {
  return useQuery({
    queryKey: ['report', 'tax', params],
    queryFn: () => getTaxReport(params),
    placeholderData: keepPreviousData,
    staleTime: 30000,
    refetchOnWindowFocus: false
  });
}
